import type { IVRInfo } from "@/sdk";
import type { CallIntroStep } from "../../call-intro-flow/store/CallIntroStore";
import type { CustomerVerificationStep } from "../types";

export function isIVRHandoffStep({
    callIntroStep,
    stepHistory,
    isEnhancedCustomerSearchEnabled,
    ivrInfo,
}: {
    callIntroStep: CallIntroStep;
    stepHistory: CustomerVerificationStep[];
    isEnhancedCustomerSearchEnabled: boolean;
    ivrInfo?: IVRInfo;
}) {
    const isSaasIVRHandoffStep = isEnhancedCustomerSearchEnabled && callIntroStep === "CustomerInfoCollection";
    const isStandardIVRHandoffStep =
        !isEnhancedCustomerSearchEnabled && stepHistory.at(stepHistory.length - 1) === "CustomerPhoneInput";
    return (isSaasIVRHandoffStep && !!ivrInfo?.intent) || (isStandardIVRHandoffStep && hasIVRInfo(ivrInfo));
}

export function hasIVRInfo({ intent, device, summary, productLink }: IVRInfo = {}): boolean {
    return !!intent || !!device || !!summary || !!productLink;
}
